import React from 'react';
import Layout from "../../../components/Layout";
import FeedPost from "../../../components/FeedPost";
import {wrapper} from "../../../store";
import {getBlogPostsByCategory, getRunningQueriesThunk, useGetBlogPostsByCategoryQuery} from "../../../rtk-api/blog";
import {NextSeo} from "next-seo";
import Breadcrumbs from "../../../components/inc/breadcrumbs";

export const getServerSideProps = wrapper.getServerSideProps(store => async ({req, params}) => {
	const {id} = params
	
	store.dispatch(getBlogPostsByCategory.initiate(id));
	await Promise.all(store.dispatch(getRunningQueriesThunk()));
	
	return {
		props: {id},
	};
});


function Index(props) {
	
	const {data:category} = useGetBlogPostsByCategoryQuery(props.id)
	
	return (
		<Layout >
			<NextSeo
				title={`Category ${category?.category.name} - PageName Blog`}
				description={`Results for the category - ${category?.category.name}`}
			/>
			<section className="px-5 pb-20">
				<div className="container">
					
					<Breadcrumbs
						href={'/category/' + category?.category.name}
						text={category?.category.name}
					/>
					
					<h3 className="heading text-3xl mb-5">Posts in "<u>{category?.category.name}</u>"</h3>
					
					<div className="md:grid md:grid-cols-2">
						{category.posts.map((post, index) =>
							<FeedPost post={post} key={index} />
						)}
					</div>
				</div>
			</section>
		</Layout>
	);
}

export default Index;
